import React from 'react';
import { useAppStore, type Section } from '@/store/app';
import { useAuthStore } from '@/store/auth';

const DroneIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
    <rect x="9.5" y="9.5" width="5" height="5" rx="1.2"/>
    <line x1="9.5" y1="9.5" x2="4.5" y2="4.5"/>
    <line x1="14.5" y1="9.5" x2="19.5" y2="4.5"/>
    <line x1="9.5" y1="14.5" x2="4.5" y2="19.5"/>
    <line x1="14.5" y1="14.5" x2="19.5" y2="19.5"/>
    <circle cx="4" cy="4" r="2.2"/>
    <circle cx="20" cy="4" r="2.2"/>
    <circle cx="4" cy="20" r="2.2"/>
    <circle cx="20" cy="20" r="2.2"/>
    <circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none"/>
  </svg>
);

const NAV: Array<{ id: Section; icon?: string; title: string; custom?: React.ReactNode }> = [
  { id: 'panel',       icon: 'ti-layout-grid', title: 'Panel' },
  { id: 'plano',       title: 'Drone',         custom: <DroneIcon /> },
  { id: 'territorio',  icon: 'ti-building',    title: 'Territorio' },
  { id: 'seguimiento', icon: 'ti-checklist',   title: 'Seguimiento' },
  { id: 'ajustes',     icon: 'ti-settings',    title: 'Ajustes' },
];

export default function Dock() {
  const { section, searchOpen, isDark, setSection, toggleSearch, abrirVivienda } = useAppStore();
  const inst = useAuthStore((s) => s.institucion);
  const isSistematizador = inst?.slug === 'sistematizador';
  if (isSistematizador) return null;

  const bg = isDark ? 'rgba(10,20,50,0.97)' : 'rgba(10,22,40,0.88)';
  const border = isDark ? '1px solid rgba(100,160,255,0.22)' : '1px solid rgba(255,255,255,0.08)';
  const iconInactive = isDark ? 'rgba(200,220,255,0.75)' : 'rgba(255,255,255,0.48)';
  const iconActive = '#60A5FA';
  const iconActiveBg = isDark ? 'rgba(96,165,250,0.28)' : 'rgba(96,165,250,0.2)';
  const divider = isDark ? 'rgba(100,160,255,0.25)' : 'rgba(255,255,255,0.15)';

  return (
    <div style={{
      position: 'absolute', bottom: 22, left: '50%', transform: 'translateX(-50%)',
      zIndex: 40, background: bg, backdropFilter: 'blur(20px)',
      borderRadius: 26, padding: '10px 18px', display: 'flex', gap: 20, alignItems: 'center',
      boxShadow: isDark ? '0 14px 34px rgba(0,0,0,0.6), 0 0 0 1px rgba(100,160,255,0.15)' : '0 14px 34px rgba(0,0,0,0.25)',
      border,
      animation: 'floatIn 400ms ease-out',
    }}>
      {NAV.map((n) => {
        const active = n.id === section;
        return (
          <button
            key={n.id}
            title={n.title}
            onClick={() => setSection(n.id)}
            style={{
              width: 42, height: 42, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 19,
              background: active ? iconActiveBg : 'transparent',
              color: active ? iconActive : iconInactive,
              transition: 'color 200ms, background 200ms',
            }}
          >
            {n.custom ?? <i className={`ti ${n.icon}`} />}
          </button>
        );
      })}
      <div style={{ width: 1, height: 22, background: divider }} />
      <button
        title="Asistente IA"
        onClick={toggleSearch}
        style={{
          width: 42, height: 42, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 18, color: '#fff',
          background: searchOpen ? 'linear-gradient(135deg,#60A5FA,#1D4ED8)' : 'linear-gradient(135deg,#1D4ED8,#60A5FA)',
          animation: searchOpen ? undefined : 'glowPulse 2.2s ease-in-out infinite',
          boxShadow: searchOpen ? '0 0 0 2px rgba(96,165,250,0.3),0 6px 16px rgba(29,78,216,0.5)' : undefined,
        }}
      >
        <i className="ti ti-sparkles" />
      </button>
      <button
        title="Registrar vivienda"
        onClick={abrirVivienda}
        style={{ width: 42, height: 42, borderRadius: '50%', background: '#1D4ED8', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 19, boxShadow: '0 6px 16px rgba(29,78,216,0.55)' }}
      >
        <i className="ti ti-plus" />
      </button>
    </div>
  );
}
